export default __webpack_public_path__ + "static/media/cpp.b56a142e.png";